/** @jsx h */
import { h } from 'preact'
import LeftIcon from '../icons/LeftIcon'
import RightIcon from '../icons/RightIcon'

const JourneyNavigation = props => {
  const { id, next, previous, index, total } = props

  return (
    <nav class='JourneyNavigation'>
      <div class='JourneyNavigation-inner'>
        <a
          href={`#${id}-${index}`}
          class='JourneyNavigation-button'
          onClick={previous}
          disabled={index < 1}
        >
          <LeftIcon />
        </a>
        <a
          href={`#${id}-${index}`}
          class='JourneyNavigation-button'
          onClick={next}
          disabled={index === total - 1}
        >
          <RightIcon />
        </a>
      </div>
    </nav>
  )
}

export default JourneyNavigation
